import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {Table, Tooltip} from "reactstrap";
import classnames from "classnames";

import {getCurrentMicroTime} from "../../../../../reducers/timeMeasuring/actions";
import RadioIcon from "../../Components/radioIcon";
import QuestionContainer from "../../Components/questionContainer";
import AnswerContainer from "../../Components/answerContainer";
import ImageOpenAnswer from "../../Components/imageOpenAnswer";

class PresentationScale extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false
    };

    this.selectItem = this.selectItem.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.isTooltipOpen = this.isTooltipOpen.bind(this);
  }

  toggleTooltip(value) {
    if (this.state.tooltipOpen === value) {
      this.setState({tooltipOpen: false});
    }else{
      this.setState({tooltipOpen: value});
    }
  }

  isTooltipOpen(value) {
    return this.state.tooltipOpen === value;
  }

  selectItem(answer) {
    const detail = this.props.details.length > 0 ? this.props.details[0] : false;

    if((detail && detail.answer === answer)){
      return;
    }

    const microTime = getCurrentMicroTime(this.props.startTime);
    this.props.onDetailsUpdated([{
      answer,
      microTime
    }]);

    this.props.question.javascripts.map(javascript => {
      if(javascript.action === 'onAnswerSelected'){
        let func = new Function("return " + "function (answer) { " + javascript.code + " }")().bind(this);
        func(answer);
      }
    });
  }

  onOpenChange(e){
    const detail = this.props.details[0];

    this.props.onDetailsUpdated([{
      answer: detail.answer,
      content: e.target.value
    }]);
  }

  render() {
    const {answers, details, answersColumns, answersImage} = this.props;
    const detail = details.length > 0 ? details[0] : false;

    const style = {
      width: ((100 / answers.length).toFixed(0)) + '%',
    };

    return (
        <React.Fragment>
          <div className={"d-block d-lg-none"}>
            <QuestionContainer
                gridLine={!answersImage}
                answersColumns={answersColumns}
                component={<React.Fragment>
                  {answers.map((answer) => {
                    const checked = detail && parseInt(detail.answer) === answer.id;

                    return <AnswerContainer
                        checked={checked}
                        answer={answer}
                        onClick={(e) => {
                          if(e.target.tagName != 'INPUT'){
                            this.selectItem(answer.id)
                          }
                        }}
                        component={
                          <ImageOpenAnswer
                              answer={answer}
                              detail={detail}
                              checked={checked}
                              isTooltipOpen={this.isTooltipOpen(answer.id)}
                              toggleTooltip={() => this.toggleTooltip(answer.id)}
                              checkboxType={'radio'}
                              answersImage={answersImage}
                              showInput={(answer.isOpen && checked)}
                              showContent={(answer.isOpen && checked) === false}
                              onOpenChange={this.onOpenChange}
                              answerOpenAlwaysShow={true}
                          />
                        }
                    />
                  })}
                </React.Fragment>}
            />
          </div>
          <div className={"d-none d-lg-block"}>
            <QuestionContainer
                classes={"scale-grid"}
                gridLine={true}
                answersColumns={answers.length}
                component={<React.Fragment>
                  {answers.map((answer) => {
                    const checked = detail && parseInt(detail.answer) === answer.id;

                    return <AnswerContainer
                        classes={"text-center"}
                        checked={checked}
                        answer={answer}
                        onClick={(e) => {
                          if(e.target.tagName != 'INPUT'){
                            this.selectItem(answer.id)
                          }
                        }}
                        component={
                          <React.Fragment>
                            <ImageOpenAnswer
                                answer={answer}
                                detail={detail}
                                checked={checked}
                                isTooltipOpen={this.isTooltipOpen(answer.id)}
                                toggleTooltip={() => this.toggleTooltip(answer.id)}
                                checkboxType={''}
                                answersImage={answersImage}
                                showInput={false}
                                showContent={true}
                                onOpenChange={this.onOpenChange}
                                answerOpenAlwaysShow={false}
                            />
                            {checked && answer.isOpen && <ImageOpenAnswer
                                answer={answer}
                                detail={detail}
                                checked={checked}
                                checkboxType={''}
                                answersImage={false}
                                showInput={true}
                                showContent={false}
                                onOpenChange={this.onOpenChange}
                                answerOpenAlwaysShow={false}
                            />}
                            <RadioIcon classes={"align-self-center pb-3 pt-3"} checked={checked} />
                          </React.Fragment>
                        }
                    />
                  })}
                </React.Fragment>}
            />
          </div>
        </React.Fragment>
    );
  }
}

PresentationScale.propTypes = {
  question: PropTypes.shape({
    javascripts: PropTypes.array.isRequired,
  }).isRequired,
  answers: PropTypes.array.isRequired,
  answersImage: PropTypes.bool.isRequired,
  details: PropTypes.array.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
})(PresentationScale);